<template lang="pug">
    mt-popup.popup-full-picker(v-model="showPicker", :position="position")
        mt-header.popup-full-header(:title="popupTypeText")
            div(slot="left", @click="popupHandle")
                mt-button(icon="back") 返回
            mt-button(slot="right") {{subText}}
        scroll.popup-full-body(ref="scrollWrapper")
            .result-box
                .item(:class="{'select': currentIndex === index}" @click="submitHandle(item)" v-for="(item, index) in results" :key="index" :index="index") {{item.txt || item.pickupTime}}
</template>
<script>
    import scroll from './scroll'
    export default {
        name: 'popup-picker-component',
        props: {
            popupTypeText: {
                type: String,
                default: '请选择'
            },
            subText: {
                type: String,
                default: ''
            },
            showPicker: {
                type: Boolean,
                default: false
            },
            results: {
                type: Array,
                required: true
            },
            position: {
                type: String,
                default: 'right'
            }
        },
        data () {
            return {
                currentIndex: null
            }
        },
        mounted() {
            console.log(this.results)
        },
        watch: {
            showPicker () {
                setTimeout(() => {
                    this.$refs.scrollWrapper.refresh()
                }, 20)
            }
        },
        methods: {
            selectHandle (index) {
                this.currentIndex = index
            },
            popupHandle () {
                this.$emit('popupHandle')
            },
            submitHandle (item) {
                this.$emit('submitHandle', item)
            }
        },
        components: {
            scroll
        }
    }
</script>
<style lang="scss">
    $headerHeight: 40px;
    .popup-full-picker{
        width: 100%;
        height: 100%;
    }
    .popup-full-body {
        position: fixed;
        top: $headerHeight;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1 !important;
    }
    .result-box {
        position: relative;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            transform: scaleY(0.5);
            transform-origin: 50% 100%;
            border-top: 1px solid #d2d2d2;
        }
        .item {
            font-size: 14px;
            padding: 13px 20px;
            color: #666;
            position: relative;
            transition: 0.3s ease-out;
            &.select {
                background: #f2f3f4;
            }
            &:after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                transform: scaleY(0.5);
                transform-origin: 50% 100%;
                border-bottom: 1px solid #d2d2d2;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/popup-full-picker.vue